import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';

/**
 * @see app/Http/Resources/Project/ProjectStatusResource.php
 * TODO: `type` below should be an enum. See constants ProjectStatus::STATUS_* constants in PHP.
 */
export class ProjectStatus {
  constructor(
    public readonly id: number,
    public readonly type: string,
    public readonly title: string,
    // Description with HTML removed and safe for outputting like v-html
    public readonly descriptionSanitized: string,
  ) {}
}

defineTransform(ProjectStatus, (_json, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
  };
});
